module.exports = __webpack_public_path__ + "img/02-Eisai_BG_bk.0805adb2.jpg";